import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入封装好的request请求
import request from './utils/request'
Vue.config.productionTip = false
// 全局注册ElementUI
Vue.use(ElementUI)
// 挂载到全局，两种用法都支持
Vue.prototype.$axios = axios
Vue.prototype.$request = request
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
